import React from "react";

export const Loading = ({ inlineStyle = undefined }) => (
	<div className="loader-backdrop" style={inlineStyle}>
		<div className="loading-indicator-container">
			<div className="loading-indicator loading-indicator-in" />
			<div className="loading-indicator loading-indicator-out" />
		</div>
	</div>
);
